import { useRestClient } from '@/contexts/QueryProvider'

export function ProjectName({ projectId }: { projectId?: number }) {
  const { getSupportApiGetProjectsWithAdmins } = useRestClient()

  const { data: projects } = getSupportApiGetProjectsWithAdmins.useSuspenseQuery(undefined)

  if (!projectId) return <></>
  const project = projects.find((x) => x.projectId == projectId)

  return <>{project?.projectName}</>
}
